import React from 'react';
import { MapPin, Mail, Instagram, Send } from 'lucide-react';
import { mockData } from '../mock';

const Contact = () => {
  // FormSubmit will handle the form submission and redirect
  const formSubmitUrl = "https://formsubmit.co/laugonzalez.mua@gmail.com";
  const thankYouUrl = `${window.location.origin}/thank-you`;

  return (
    <div className="px-6 sm:px-12 lg:px-20 pt-32 sm:pt-40 pb-20 sm:pb-24">
      <div className="max-w-3xl mx-auto">
        
        {/* Page Title - Small & Elegant */}
        <div className="mb-16 sm:mb-20 text-center">
          <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extralight text-black mb-6 tracking-wide">
            Get in Touch
          </h1>
          <div className="w-12 h-px bg-black/30 mx-auto mb-8"></div>
          <p className="text-xs sm:text-sm text-black/60 max-w-lg mx-auto leading-loose font-light">
            Ready to elevate your beauty? Let's discuss your vision.
          </p>
        </div>

        {/* Contact Form - Minimal */}
        <form action={formSubmitUrl} method="POST" className="space-y-6 sm:space-y-8 mb-20 sm:mb-24">
          {/* Hidden fields for FormSubmit configuration */}
          <input type="hidden" name="_next" value={thankYouUrl} />
          <input type="hidden" name="_subject" value="New Contact Form Submission - Laura Gonzalez Artistry" />
          <input type="hidden" name="_captcha" value="false" />
          
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="name" className="block text-[10px] tracking-[2px] uppercase font-light text-black mb-3">
                Name *
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full px-0 py-3 bg-transparent border-b border-black/20 text-black focus:outline-none focus:border-black transition-colors font-light"
                placeholder="Your name"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-[10px] tracking-[2px] uppercase font-light text-black mb-3">
                Email *
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-0 py-3 bg-transparent border-b border-black/20 text-black focus:outline-none focus:border-black transition-colors font-light"
                placeholder="your@email.com"
              />
            </div>
          </div>

          <div>
            <label htmlFor="subject" className="block text-[10px] tracking-[2px] uppercase font-light text-black mb-3">
              Subject *
            </label>
            <input
              type="text"
              id="subject"
              name="subject"
              required
              className="w-full px-0 py-3 bg-transparent border-b border-black/20 text-black focus:outline-none focus:border-black transition-colors font-light"
              placeholder="What can we help you with?"
            />
          </div>

          <div>
            <label htmlFor="message" className="block text-[10px] tracking-[2px] uppercase font-light text-black mb-3">
              Message *
            </label>
            <textarea
              id="message"
              name="message"
              required
              rows={6}
              className="w-full px-0 py-3 bg-transparent border-b border-black/20 text-black focus:outline-none focus:border-black transition-colors resize-none font-light"
              placeholder="Tell us about your event or project..."
            />
          </div>

          <button
            type="submit"
            className="inline-flex items-center justify-center gap-3 px-12 py-5 border border-black text-black text-[10px] tracking-[2px] uppercase font-light hover:bg-black hover:text-white transition-all duration-300 group"
          >
            Send Message
            <Send size={14} strokeWidth={1} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </form>

        {/* Thin divider */}
        <div className="w-full h-px bg-black/10 mb-16 sm:mb-20"></div>

        {/* Contact Information - Minimal */}
        <div className="space-y-10 sm:space-y-12">
          <h2 className="text-xl sm:text-2xl lg:text-3xl font-light text-black tracking-wide text-center mb-10 sm:mb-12">
            Contact Information
          </h2>
          
          <div className="grid md:grid-cols-2 gap-10 sm:gap-12 max-w-xl mx-auto">
            <div className="flex items-start gap-4">
              <MapPin size={16} strokeWidth={1} className="text-black mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light text-black mb-2">Location</h3>
                <p className="text-xs sm:text-sm text-black/60 leading-relaxed font-light">
                  {mockData.brand.location}<br />
                  Available for on-location services
                </p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <Mail size={16} strokeWidth={1} className="text-black mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light text-black mb-2">Email</h3>
                <a href={`mailto:${mockData.contact.email}`} className="text-xs sm:text-sm text-black/60 hover:text-black transition-colors font-light border-b border-black/20 hover:border-black">
                  {mockData.contact.email}
                </a>
              </div>
            </div>

            <div className="flex items-start gap-4 md:col-span-2">
              <Instagram size={16} strokeWidth={1} className="text-black mt-1 flex-shrink-0" />
              <div>
                <h3 className="text-[9px] sm:text-[10px] tracking-[2px] uppercase font-light text-black mb-2">Instagram</h3>
                <a 
                  href={mockData.contact.instagramUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-xs sm:text-sm text-black/60 hover:text-black transition-colors font-light border-b border-black/20 hover:border-black"
                >
                  {mockData.contact.instagram}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
